export const FILTERED_ITEMS_SECTION_REQUEST = "FILTERED_ITEMS_SECTION_REQUEST";
export const FILTERED_ITEMS_SECTION_SUCCESS = "FILTERED_ITEMS_SECTION_SUCCESS";
export const FILTERED_ITEMS_SECTION_ERROR = "FILTERED_ITEMS_SECTION_ERROR";
